import React from 'react';
import {
  SortingContainer,
  SortLabel,
  StyledSortContainer,
  StyledSortIcon,
} from './styled.sort';
import { ChevronDown } from '../../icons/ChevronDown';
import { ChevronUp } from '../../icons/ChevronUp';
import { ChevronUpAndDown } from '../../icons/ChevronUpAndDown';
import { Filter, ISort } from '../../../@types/sort';

export function Sort ({ filters }: ISort) {
  const initialWidth = 100 / 2 + '%';
  const filterWidth = 100 / 4 + '%';

  return (
    <StyledSortContainer data-testid="sort">
      {filters &&
        filters.map((filter: Filter, index) => (
          <SortingContainer
            key={filter.id}
            width={index === 0 ? initialWidth : filterWidth}
            onClick={() => filter.callback(filter.id, filters)}
          >
            <SortLabel>{filter.label}</SortLabel>
            <StyledSortIcon>
              {filter.id && !filter.sortingDirection && <ChevronUpAndDown />}
              {filter.sortingDirection === 'asc' && <ChevronDown />}
              {filter.sortingDirection === 'desc' && <ChevronUp />}
            </StyledSortIcon>
          </SortingContainer>
        ))}
    </StyledSortContainer>
  );
}
